import { BookingPolicyDto } from '../../types/shared-types';

export interface PolicySectionViewModel {
  cancellationPolicy?: string;
}
export const policySectionViewModelFactory = (
  bookingPolicyDto: BookingPolicyDto,
): PolicySectionViewModel => {
  return {
    cancellationPolicy: bookingPolicyDto.cancellationPolicy,
  };
};
